(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const designMode = () => Boolean(window.Shopify && Shopify.designMode);
  function initEffects(scope = document) {
    scope.querySelectorAll('[data-dela-effect]:not([data-dela-effect-ready])').forEach((el) => {
      el.dataset.delaEffectReady = 'true';
      const effect = el.dataset.delaEffect;
      const once = el.dataset.delaEffectOnce === 'true';
      const key = `dela-effect:${el.dataset.delaEffectKey || effect}`;
      if (effect === 'none' || reduceMotion.matches) { el.remove(); return; }
      if (once && !designMode() && sessionStorage.getItem(key)) { el.remove(); return; }
      if (once && !designMode()) sessionStorage.setItem(key, '1');
      [...el.children].forEach((piece, i) => {
        piece.style.setProperty('--x', `${(i * 37) % 96}%`);
        piece.style.setProperty('--delay', `${(i % 7) * .11}s`);
        piece.style.setProperty('--drift', `${((i % 5) - 2) * 26}px`);
        piece.style.setProperty('--rot', `${(i * 47) % 360}deg`);
      });
      window.setTimeout(() => el.classList.add('dela-v21-effect--done'), 4200);
    });
  }
  function initHomeMobileNav() {
    const nav = document.querySelector('.dela-mobile-cta');
    if (!nav) return;
    const isHome = document.body.classList.contains('template-index');
    if (!isHome || designMode()) { nav.classList.add('dela-v21-mobile-nav--visible'); return; }
    nav.classList.add('dela-v21-mobile-nav--auto');
    const update = () => {
      const hero = document.querySelector('[data-dela-v3-hero]');
      const threshold = hero ? Math.max(180, hero.offsetTop + hero.offsetHeight * .62) : Math.min(300, window.innerHeight * .34);
      nav.classList.toggle('dela-v21-mobile-nav--visible', window.scrollY > threshold);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    nav.addEventListener('focusin', () => nav.classList.add('dela-v21-mobile-nav--visible'));
  }
  function init() { initEffects(document); initHomeMobileNav(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', (e) => initEffects(e.target));

  window.addEventListener('pageshow', (e) => { if (e.persisted) { document.querySelectorAll('[data-dela-effect]').forEach(el => { const clone = el.cloneNode(true); clone.classList.remove('dela-v21-effect--done'); clone.removeAttribute('data-dela-effect-ready'); el.replaceWith(clone); }); initEffects(document); } });
})();
